import { useTranslation } from 'react-i18next'

import { FieldStackedLabel } from '../../Field'
import { FormFieldsContainer } from '../../Form'
import { FormikField, getFormikFormFieldErrorProps } from '../../Formik'
import { InputField } from '../../Input'

function UserEditTextFieldFormModalFieldsWithoutActionType({
  fieldLabelKey,
  fieldMaxLength,
  fieldName,
  fieldPlaceholderKey,
  fieldRequired,
}) {
  const { t } = useTranslation()

  return (
    <FormFieldsContainer>
      <FormikField
        autoFocus
        clearable
        Component={InputField}
        Field={FieldStackedLabel}
        fieldComponentProps={{
          label: `${t(fieldLabelKey)}:`,
          required: fieldRequired,
        }}
        getErrorProps={getFormikFormFieldErrorProps}
        maxLength={fieldMaxLength}
        name={fieldName}
        placeholder={t(fieldPlaceholderKey)}
      />
    </FormFieldsContainer>
  )
}

export default UserEditTextFieldFormModalFieldsWithoutActionType
